<div class="row js-help-layer map-layer-2">
	<div class="col-xs-10">
		<div class="form-inline m-b-5">
			<div class="btn-group m-b-5">
				<button id="js-refresh" class="btn btn-sm btn-default btn-group"  data-toggle="tooltip" data-placement="bottom" title="{{TR "Refresh"}}">
					<i class="fa fa-refresh"></i>
				</button>
				<button id="js-toggle-auto-refresh" class="btn btn-sm btn-default btn-group {{#if autoRefresh}}btn-selected{{/if}}" data-toggle="tooltip" data-placement="bottom" title="{{TR "Auto-Refresh"}}">
					<i class="fa fa-history"></i>
				</button>
			</div>
			<div class="btn-group m-b-5">
				<button id="js-zoom-out" class="btn btn-sm btn-default btn-group" data-toggle="tooltip" data-placement="bottom" title="{{TR "Verkleinern"}}">
					<i class="fa fa-search-minus"></i>
				</button>
				<button id="js-zoom-in" class="btn btn-sm btn-default btn-group" data-toggle="tooltip" data-placement="bottom" title="{{TR "Vergrößern"}}">
					<i class="fa fa-search-plus"></i>
				</button>
				<button id="js-zoom-reset" class="btn btn-sm btn-default btn-group"  data-toggle="tooltip" data-placement="bottom" title="{{TR "Zoom zurücksetzen"}}">
					<i class="fa fa-search"></i>
				</button>
				<button id="js-toggle-fullscreen" class="btn btn-sm btn-default btn-group"  data-toggle="tooltip" data-placement="bottom" title="{{TR "Vollbild"}}">
					<i class="fa fa-arrows-alt"></i>
				</button>
			</div>
			<div class="form-group m-b-5 m-r-10">
				{{#SELECT field_select}}
				<select class="selectpicker js-filter-select" data-style="btn-white btn-sm" id="df-field">
					{{#each fields}}
					<option value="{{id}}">{{TR name}}</option>
					{{/each}}
				</select>
				{{/SELECT}}
			</div>
			<div id="style_config" class="form-group m-b-5 {{#unless field_select}}camouflage{{/unless}}">
				<div class="checkbox checkbox-primary">
					<input id="js-toggle-icons" type="checkbox" {{#if icons}}checked="checked"{{/if}}>
					<label for="js-toggle-icons">{{TR "Icons"}}</label>
				</div>
				<div class="checkbox checkbox-primary">
					<input id="js-toggle-label" type="checkbox" {{#if labels}}checked="checked"{{/if}}>
					<label for="js-toggle-label">.. {{TR "als Text"}}</label>
				</div>
				<div class="checkbox checkbox-primary">
					<input id="js-toggle-heatmap" type="checkbox" {{#if heatmap}}checked="checked"{{/if}}>
					<label for="js-toggle-heatmap">{{TR "Heatmap"}}</label>
				</div>
			</div>
		</div>
	</div>
	<div class="col-xs-2">
		<div class="btn-group m-b-5 pull-right">
			<button class="btn btn-primary btn-sm js-show-filter">
				<i class="fa fa-filter"></i>
			</button>
			<button class="btn btn-primary btn-sm js-reset-filter">
				<i class="fa fa-trash"></i>
			</button>
		</div>
	</div>
</div>

